<template>
  <ag-grid-vue         
    ref="grid"
    style="width: 100%; height: 70vh; min-height: 400px;"
    class="ag-theme-alpine"    
    row-selection="multiple"                                  

    :column-defs="columnDefs"     
    :grid-options="gridOptions"
    :default-col-def="defaultColDef"
    :row-data="boardList"
    :framework-components="frameworkComponents"      
    @rowDoubleClicked="rowDoubleClick"
    @grid-ready="onReady"        
        
  />
</template>

<script>
import AgGridScanAttach from '@/components/agGrid/AgGridScanAttach'

export default {
    name:'ListSaleSupportGuide',
    props:{
        boardList:{
            type:Array,
            required: true
        },
        title:{
            type:String,
            required: true
        },
        boardCd:{
            type:String,
            required: true
        },
    },
    data(){
        return {
            /**ag-grid */
            gridOptions: {         
            // onColumnResized: true,
            // enableFilter: true,
            // enableSorting: true,
            // suppressRowTransform: true
            },
            frameworkComponents: {
               AgGridScanAttach: AgGridScanAttach,
            },
            defaultColDef: {         
                resizable: true,
                filter: true,
                sortable: true,
                //editable: true
            },              
            gridApi : null ,    //gridAip
            columnApi : null ,  //columApi
            columnDefs: [] ,    //comulum Defs  
                    
        }
    },
    mounted(){

    },
    methods: {
         //그리드 Ready
        onReady() {
            this.gridApi = this.gridOptions.api;
            this.columnApi = this.gridOptions.columnApi;
            
            this.createColumnDefs();

            //this.query()
        },
        //컬럼정의 함수
        createColumnDefs() { 
            
            this.columnDefs = [
            { headerName: '번호'
                , width : 100
                , valueGetter: (params) => {return params.node.rowIndex + 1 }
                , filter: false
                , sortable: false
                , editable: false
                , cellStyle:{textAlign: 'center'}
                },
                {
                    headerName: '제목'
                , width : 1045 
                , field: 'bSubject'
                , cellStyle:{textAlign: 'left'}
                },
                {
                    headerName: '게시일'
                , width : 120 
                , field: 'creationDate'
                , cellStyle:{textAlign: 'center'}
                },
                {
                    headerName: '게시자',
                    width : 150 ,
                    field: 'createdBy',
                    cellStyle:{textAlign: 'center'}
                },
                {
                    headerName: '첨부파일',
                    width : 200 ,
                    field: 'fileYN',
                    cellRenderer: 'AgGridScanAttach',
                    cellStyle:{textAlign: 'center'}
                }                                         
            ];
        },
        rowDoubleClick(params){
            this.$router.push({          
                name: 'boardRead',
                params: {
                    title : this.title,
                    boardCd: this.boardCd,
                    boardId : params.data.id 
                }
            })
            const boardInfo={};
            boardInfo.title = this.title
            boardInfo.boardCd = this.boardCd
            boardInfo.boardId = params.data.id
            this.$store.commit('boardCd', boardInfo)  
        },
    },
    

    
}
</script>